import { render, staticRenderFns } from "./TicketDetalle.vue?vue&type=template&id=e441bd28&scoped=true"
import script from "./TicketDetalle.vue?vue&type=script&lang=js"
export * from "./TicketDetalle.vue?vue&type=script&lang=js"
import style0 from "./TicketDetalle.vue?vue&type=style&index=0&id=e441bd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e441bd28",
  null
  
)

export default component.exports